import script from "./ClickableArea.vue?vue&type=script&lang=ts&setup=true"
export * from "./ClickableArea.vue?vue&type=script&lang=ts&setup=true"

import "./ClickableArea.vue?vue&type=style&index=0&id=8b6dbf0c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b6dbf0c"]])

export default __exports__